import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../context/AuthContext';

// Renders only when an admin is currently impersonating another user. Detected
// by the presence of `originalToken` in localStorage (set by adminService
// .impersonate() in the admin user-detail modal). Clicking 'Stop' restores
// the original admin token and reloads.
export const ImpersonationBanner = () => {
  const { user } = useContext(AuthContext);
  const [impersonating, setImpersonating] = useState(() => !!localStorage.getItem('originalToken'));

  useEffect(() => {
    setImpersonating(!!localStorage.getItem('originalToken'));
  }, [user]);

  if (!impersonating) return null;

  const stop = () => {
    const original = localStorage.getItem('originalToken');
    if (original) {
      localStorage.setItem('token', original);
      localStorage.removeItem('originalToken');
    }
    window.location.assign('/admin');
  };

  return (
    <div className="bg-amber-500 text-gray-900 text-sm font-semibold">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-between gap-3">
        <span>
          ⚠️ Impersonating <span className="font-bold">{user?.email || 'user'}</span> — actions you take are logged.
        </span>
        <button onClick={stop} className="px-3 py-1 bg-gray-900 text-amber-300 rounded font-bold text-xs hover:bg-black">
          Stop & return to admin
        </button>
      </div>
    </div>
  );
};
